import Cart from 'cart-store';

/*
  Adds the ticked add-ons (ls-product-addons.liquid) alongside the product.

  On products with installation, ls-install-estimator.js already owns the
  submit and reads the ticked add-ons itself, so this stays out of the way.
  Without it, this steps in only when something is ticked; otherwise the
  theme's product-form adds the product as usual.
*/
if (!customElements.get('ls-product-addons')) {
  customElements.define(
    'ls-product-addons',
    class LsProductAddons extends HTMLElement {
      connectedCallback() {
        this.form = document.getElementById(this.dataset.formId);
        if (!this.form || this.form.querySelector('ls-install-estimator')) return;

        this.onSubmit = this.onSubmit.bind(this);
        /* Capture phase so we run before the theme's product-form, which can
           only add one line. */
        this.form.addEventListener('submit', this.onSubmit, true);
      }

      disconnectedCallback() {
        if (this.onSubmit) this.form.removeEventListener('submit', this.onSubmit, true);
      }

      async onSubmit(event) {
        const addons = [...this.form.querySelectorAll('input[data-ls-addon]:checked')];
        if (!addons.length) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        const staged = this.form.closest('product-form')?.querySelector('staged-action');
        const data = Object.fromEntries(new FormData(this.form).entries());
        this.removeError();

        try {
          await this.stage(staged, 'DOING');
          await Cart.add([
            { id: data.id, quantity: Number(data.quantity) || 1 },
            ...addons.map((input) => ({ id: input.value, quantity: 1 })),
          ]);
          await this.stage(staged, 'DONE');
          this.openCartDrawer();
        } catch (error) {
          await this.stage(staged, 'IDLE');
          this.showError(error.message);
        }
      }

      /* Same reasoning as ls-install-estimator.js: the tick animation is
         decoration and must not turn a successful add into an error. */
      async stage(staged, state) {
        if (!staged) return;
        try {
          await staged.setState(state);
        } catch (error) {
          /* ignore */
        }
      }

      openCartDrawer() {
        const drawer = document.querySelector('.modal--cart, .popup--cart-notification');
        if (!drawer) return;
        if (!drawer.shown && typeof drawer.open === 'function') drawer.open();
        else if (drawer.interval) {
          drawer.interval.reset();
          drawer.interval.start();
        }
      }

      removeError() {
        const existing = this.form.querySelector('.lsie-error');
        if (existing) existing.remove();
      }

      showError(message) {
        this.removeError();
        const button = this.form.elements.add;
        if (!button) return;
        const el = document.createElement('div');
        el.className = 'errors qty-error u-small lsie-error';
        el.textContent = message || 'Something went wrong. Please try again.';
        button.before(el);
      }
    },
  );
}
